var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MoneyFormat',{staticClass:"money-format",style:(_vm.style),attrs:{"value":_vm.price,"currency-code":_vm.currencyCodeToUse,"hide-subunits":_vm.roundingTypeToUse == 1}})
}
var staticRenderFns = []

export { render, staticRenderFns }